import { LineSeparator } from '@/components/LineSeparator';
import { useRole } from '@/hooks/UseRole';
import { UpdateCompanyGeneralDelete } from '@/partials/dashboard/Companies/UpdateCompany/General/UpdateCompanyGeneralDelete';
import { UpdateCompanyGeneralInformations } from '@/partials/dashboard/Companies/UpdateCompany/General/UpdateCompanyGeneralInformations';
import { UpdateCompanyGeneralLogo } from '@/partials/dashboard/Companies/UpdateCompany/General/UpdateCompanyGeneralLogo';
import { useAuthStore } from '@/stores/useAuthStore';
import { useCompanyStore } from '@/stores/useCompanyStore';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

export const UpdateCompanyGeneralIndex = () => {
  const { user } = useAuthStore();
  const { id } = useParams<{ id: string }>();
  const isAdmin = useRole('admin');
  const companyId = isAdmin && id ? id : user?.company?.id;
  const { showCompany } = useCompanyStore();

  useEffect(() => {
    const fetchCompany = async () => {
      await showCompany(Number(companyId));
    };
    fetchCompany();
  }, [showCompany, companyId]);

  return (
    <div className="relative">
      <UpdateCompanyGeneralLogo />
      <LineSeparator className="my-6" />
      <UpdateCompanyGeneralInformations />
      {isAdmin && (
        <>
          <LineSeparator className="my-6" />
          <UpdateCompanyGeneralDelete />
        </>
      )}
    </div>
  );
};
